export default __webpack_public_path__ + "static/video_loop-ed6ab55df5444fbfd0135da82528b97b.webp";